import {
  ExternalIdentityVerificationAttributeFragment,
  ExternalIdentityVerificationProfileFragment,
  ExternalIdentityVerificationProvider,
} from '@ocx/graphql';

export const generateVerifiedStatusesString = (attributes: ExternalIdentityVerificationAttributeFragment[]): string => {
  return attributes.map((attribute) => attribute.name).join(', ');
};

type VerificationStatus = { isVerified: false } | { isVerified: true; verifiedStatusesString: string };

export const getVerificationStatus = (
  profiles: ExternalIdentityVerificationProfileFragment[] | null,
  provider: ExternalIdentityVerificationProvider,
): VerificationStatus => {
  if (!profiles || !profiles.length) return { isVerified: false };
  const profile = profiles.find((profile) => profile.provider === provider);
  if (!profile || !profile.attributes?.length) return { isVerified: false };
  return {
    isVerified: true,
    verifiedStatusesString: generateVerifiedStatusesString(profile.attributes),
  };
};
